import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useDeleteProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (projectId) => {
    return await axios.delete(`/projects/${projectId}`);
  });

  const deleteProject = (projectId, options) => {
    mutate(projectId, {
      onSuccess: (res) => {
        if (!res.data) {
          toast.error(`The module can not be deleted! `);
          return;
        }
        queryClient.invalidateQueries('projects');
        toast.success(`Successfully deleted the project! `);
        options.onSuccess && options.onSuccess(projectId);
      },
    });
  };

  return {
    deleteProject,
    isLoading,
  };
};

export default useDeleteProject;
